// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__sadND","messsage":"Loader_messsage__myrBF","move":"Loader_move__6zjEk"};